// src/store/actions/authActions.js

import { resetStore } from "./resetAction";
import { persistor } from "../index";

export const logoutAndReset = () => async (dispatch) => {
  try {
    // 1. reset redux
    dispatch(resetStore());

    // 2. purge persist
    await persistor.purge();

    // (optionnel) clear storage manuel si besoin
    // localStorage.clear();
  } catch (error) {
    console.error("Erreur lors du logout :", error);
  }
};
